// extracted by mini-css-extract-plugin
export default {"container":"Ao-z","backNav":"Bo-z"};